import { range } from 'lodash';

export const dimensionTypes = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
};

export const dimensionSequences = {
  [dimensionTypes.DAILY]: [...range(1, 8), 14, 28],
  [dimensionTypes.WEEKLY]: range(1, 11),
  [dimensionTypes.MONTHLY]: range(1, 11),
};

export const dimensionRangeSequences = {
  [dimensionTypes.DAILY]: range(1, 29),
  [dimensionTypes.WEEKLY]: range(1, 11),
  [dimensionTypes.MONTHLY]: range(1, 11),
};

export const customSequenceTypes = {
  RANGE: 'RANGE',
  MANUAL: 'MANUAL',
};

export const getDefaultSequence = (sequenceType, dimensionType) => {
  switch (sequenceType) {
    case customSequenceTypes.MANUAL:
      return dimensionSequences[dimensionType];

    case customSequenceTypes.RANGE:
      return dimensionRangeSequences[dimensionType];

    default:
      return undefined;
  }
};

export const getDefaultSequenceDimensions = (sequenceType, dimensionType) => {
  if (sequenceType === customSequenceTypes.RANGE) {
    const sequence = getDefaultSequence(sequenceType, dimensionType);
    return {
      from: sequence.at(0) || 0,
      to: sequence.at(-1) || 0,
    };
  }
  return null;
};

export const retentionViews = {
  TABLE: 'Table',
  CHART: 'Chart',
  COLUMN_CHART: 'Column chart',
  CHART_BY_DATE: 'Chart by date',
  COLUMN_CHART_BY_DATE: 'Column chart by date',
};

export const retentionCharts = [
  retentionViews.CHART,
  retentionViews.COLUMN_CHART,
  retentionViews.CHART_BY_DATE,
  retentionViews.COLUMN_CHART_BY_DATE,
];

export const RETENTION_CHART_BY_DATE_VIEWS = [
  retentionViews.CHART_BY_DATE,
  retentionViews.COLUMN_CHART_BY_DATE,
];
